<template>
<div class="deafult-view-wrapper">
    <DefaultMenuView path="pic_online_service" text="云客服在线客服"></DefaultMenuView>
</div>
</template>
<script>
import DefaultMenuView from '../components/DefaultMenuView'
export default {
  name: 'DefaultOnlineServive',
  components: {
    DefaultMenuView
  },
  data(){
    return {
    }
  },
  mounted() {
    document.querySelector('body').className='commonStyLIb'
  },      
  beforeDestroy(){
    document.querySelector('body').removeAttribute('class','commonStyLIb')
  }
}
</script>
<style scoped>
.deafult-view-wrapper{
  width: 100%;
  height: 100%;
}
</style>